import { c as _c } from "react/compiler-runtime";
import { useMemo, type ComponentProps } from "react";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import UserCICStatus from "../utils/user-cic-status/UserCICStatus";
import UserCICTypeIcon from "../utils/user-cic-type/UserCICTypeIcon";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import { buildRepAvatarItems } from "./buildRepAvatarItems";
import { getContributorLabel, type RepDirection } from "./UserPageRep.helpers";
type MobileTab = "rep" | "identity";
export default function MobileTabCards(t0) {
  const $ = _c(81);
  const {
    activeTab,
    onTabChange,
    overview,
    cicOverview,
    profile,
    repDirection,
    cicAvatarItems
  } = t0;
  overview?.contributors.data;
  let t1;
  if ($[0] !== overview?.contributors.data) {
    t1 = overview?.contributors.data ?? [];
    $[0] = overview?.contributors.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = buildRepAvatarItems(t1, 3);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const repAvatarItems = t2;
  const t3 = activeTab === "rep";
  let t4;
  if ($[4] !== onTabChange) {
    t4 = () => onTabChange("rep");
    $[4] = onTabChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `tw-relative tw-cursor-pointer tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/[0.08] tw-p-4 tw-text-left tw-transition-all tw-duration-300 tw-ease-out ${activeTab === "rep" ? "tw-bg-[#0f1014]" : "tw-bg-white/[0.02]"}`;
  const t6 = `tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition-all tw-duration-300 ${activeTab === "rep" ? "tw-border-primary-300/90 tw-bg-transparent tw-ring-2 tw-ring-primary-500/25" : "tw-border-iron-400/45 tw-bg-black/10 tw-ring-1 tw-ring-black/20"}`;
  let t7;
  if ($[6] !== activeTab) {
    t7 = activeTab === "rep" && <span className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-primary-300 tw-transition-all tw-duration-300" />;
    $[6] = activeTab;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-3 tw-z-10"><span className={t6}>{t7}</span></div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== activeTab) {
    t9 = activeTab === "rep" && <><div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-500/[0.05] tw-via-transparent tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-iron-300/25 tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-blue-400/40 tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" /></>;
    $[11] = activeTab;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `tw-relative tw-transition-opacity tw-duration-300 ${activeTab === "rep" ? "" : "tw-opacity-40"}`;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="tw-mb-1.5 tw-text-[0.6875rem] tw-font-semibold tw-uppercase tw-leading-4 tw-tracking-wider tw-text-iron-500">Total Rep</div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== overview) {
    t12 = overview ? formatNumberWithCommas(overview.total_rep) : "\u2014";
    $[14] = overview;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12) {
    t13 = <div className="tw-text-2xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-primary-400">{t12}</div>;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== activeTab || $[19] !== overview || $[20] !== repAvatarItems || $[21] !== repDirection) {
    t14 = overview && <div className="tw-mt-2.5 tw-flex tw-items-center tw-gap-2">{repAvatarItems.length > 0 && <div className={activeTab === "rep" ? "tw-pointer-events-none desktop-hover:tw-pointer-events-auto" : "tw-pointer-events-none"}><OverlappingAvatars items={repAvatarItems} size="sm" maxCount={3} /></div>}<span className="tw-text-xs tw-font-normal tw-text-iron-400">{formatNumberWithCommas(overview.contributor_count)}{" "}{getContributorLabel(repDirection, overview.contributor_count)}</span></div>;
    $[18] = activeTab;
    $[19] = overview;
    $[20] = repAvatarItems;
    $[21] = repDirection;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t10 || $[24] !== t13 || $[25] !== t14) {
    t15 = <div className={t10}>{t11}{t13}{t14}</div>;
    $[23] = t10;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t8 || $[32] !== t9) {
    t16 = <button type="button" aria-pressed={t3} onClick={t4} className={t5}>{t8}{t9}{t15}</button>;
    $[27] = t15;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t8;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const t17 = activeTab === "identity";
  let t18;
  if ($[34] !== onTabChange) {
    t18 = () => onTabChange("identity");
    $[34] = onTabChange;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const t19 = `tw-relative tw-cursor-pointer tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/[0.08] tw-p-4 tw-text-left tw-transition-all tw-duration-300 tw-ease-out ${activeTab === "identity" ? "tw-bg-[#0f1014]" : "tw-bg-white/[0.02]"}`;
  const t20 = `tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition-all tw-duration-300 ${activeTab === "identity" ? "tw-border-emerald-300/90 tw-bg-transparent tw-ring-2 tw-ring-emerald-500/25" : "tw-border-iron-400/45 tw-bg-black/10 tw-ring-1 tw-ring-black/20"}`;
  let t21;
  if ($[36] !== activeTab) {
    t21 = activeTab === "identity" && <span className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-emerald-300 tw-transition-all tw-duration-300" />;
    $[36] = activeTab;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = <div aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-3 tw-z-10"><span className={t20}>{t21}</span></div>;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== activeTab) {
    t23 = activeTab === "identity" && <><div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-emerald-500/[0.05] tw-via-transparent tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-iron-300/25 tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/40 tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" /><div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" /></>;
    $[41] = activeTab;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  const t24 = `tw-relative tw-transition-opacity tw-duration-300 ${activeTab === "identity" ? "" : "tw-opacity-40"}`;
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="tw-mb-1.5 tw-text-[0.6875rem] tw-font-semibold tw-uppercase tw-leading-4 tw-tracking-wider tw-text-iron-500">NIC</div>;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  const t26 = cicOverview?.total_cic ?? profile.cic;
  let t27;
  if ($[44] !== t26) {
    t27 = formatNumberWithCommas(t26);
    $[44] = t26;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] !== t27) {
    t28 = <div className="tw-text-2xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-white">{t27}</div>;
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  const t29 = cicOverview?.total_cic ?? profile.cic;
  let t30;
  if ($[48] !== t29) {
    t30 = <span className="tw-h-4 tw-w-4 tw-flex-shrink-0"><UserCICTypeIcon cic={t29} /></span>;
    $[48] = t29;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  const t31 = cicOverview?.total_cic ?? profile.cic;
  let t32;
  if ($[50] !== t31) {
    t32 = <span className="tw-text-xs tw-font-semibold tw-uppercase tw-text-emerald-400"><UserCICStatus cic={t31} /></span>;
    $[50] = t31;
    $[51] = t32;
  } else {
    t32 = $[51];
  }
  let t33;
  if ($[52] !== t30 || $[53] !== t32) {
    t33 = <div className="tw-mt-2.5 tw-flex tw-items-center tw-gap-1.5">{t30}{t32}</div>;
    $[52] = t30;
    $[53] = t32;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== activeTab || $[56] !== cicAvatarItems) {
    t34 = cicAvatarItems.length > 0 && <div className={activeTab === "identity" ? "tw-pointer-events-none desktop-hover:tw-pointer-events-auto" : "tw-pointer-events-none"}><OverlappingAvatars items={cicAvatarItems} size="sm" maxCount={3} /></div>;
    $[55] = activeTab;
    $[56] = cicAvatarItems;
    $[57] = t34;
  } else {
    t34 = $[57];
  }
  const t35 = cicOverview?.contributor_count ?? 0;
  let t36;
  if ($[58] !== t35) {
    t36 = formatNumberWithCommas(t35);
    $[58] = t35;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  const t37 = (cicOverview?.contributor_count ?? 0) === 1 ? "rater" : "raters";
  let t38;
  if ($[60] !== t36 || $[61] !== t37) {
    t38 = <span className="tw-text-xs tw-font-normal tw-text-iron-400">{t36}{" "}{t37}</span>;
    $[60] = t36;
    $[61] = t37;
    $[62] = t38;
  } else {
    t38 = $[62];
  }
  let t39;
  if ($[63] !== t34 || $[64] !== t38) {
    t39 = <div className="tw-mt-2 tw-flex tw-items-center tw-gap-2">{t34}{t38}</div>;
    $[63] = t34;
    $[64] = t38;
    $[65] = t39;
  } else {
    t39 = $[65];
  }
  let t40;
  if ($[66] !== t24 || $[67] !== t28 || $[68] !== t33 || $[69] !== t39) {
    t40 = <div className={t24}>{t25}{t28}{t33}{t39}</div>;
    $[66] = t24;
    $[67] = t28;
    $[68] = t33;
    $[69] = t39;
    $[70] = t40;
  } else {
    t40 = $[70];
  }
  let t41;
  if ($[71] !== t17 || $[72] !== t18 || $[73] !== t19 || $[74] !== t22 || $[75] !== t23 || $[76] !== t40) {
    t41 = <button type="button" aria-pressed={t17} onClick={t18} className={t19}>{t22}{t23}{t40}</button>;
    $[71] = t17;
    $[72] = t18;
    $[73] = t19;
    $[74] = t22;
    $[75] = t23;
    $[76] = t40;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] !== t16 || $[79] !== t41) {
    t42 = <div className="tw-grid tw-grid-cols-2 tw-gap-3">{t16}{t41}</div>;
    $[78] = t16;
    $[79] = t41;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  return t42;
}